import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {NotificationsService} from '@catcore/services';
import {ParametersService} from '@catmodules/models/parameters/services/parameters.service';
import {ActiveModal} from '@catmodules/widgets/slide-in-modal/utils/modal-ref';
import {StyleType} from '@catui/types';
import {Parameter} from 'app/modules/models/parameters/types';
import {Observable} from 'rxjs/Observable';
import {isNullOrUndefined} from 'util';
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";

@Component({
  selector: 'cat-input-parameter-list',
  templateUrl: './input-parameter-list.component.html',
  styleUrls: ['./input-parameter-list.component.scss'],
})
export class InputParameterListComponent {
  @Output() afterUpdate = new EventEmitter<Parameter[]>();

  form: FormGroup;
  private _parameters: Parameter[];
  private _dataTableSource: any[];

  styleType = StyleType;

  @Input() fileList: any;
  @Input() parentTitle = '';

  constructor(private formBuilder: FormBuilder,
              private genericResourceService: GenericResourceService,
              private activeModal: ActiveModal,
              private parametersService: ParametersService,
              private notification: NotificationsService) {
    this.form = this.formBuilder.group({
      parameters: this.formBuilder.array([]),
    });
  }

  get parameterFormArray(): FormArray {
    return this.form.get('parameters') as FormArray;
  }

  @Input()
  get parameters(): Parameter[] {
    return this._parameters;
  }

  get dataTableSource(): any[] {
    return this._dataTableSource;
  }

  set parameters(value: Parameter[]) {
    this._parameters = value;
    if (!isNullOrUndefined(this._parameters)) {
      this._dataTableSource = [];
      const formArray = this.form.controls['parameters'] as FormArray;
      while (formArray.length !== 0) {
        formArray.removeAt(0);
      }
      this._parameters.forEach((param) => {
        const formControl = this.formBuilder.group({
          key: ['', []],
          value: ['', []],
        });
        formArray.push(formControl);
        formControl.get('key').setValue(param.key);
        if (this.parametersService.isFileParameter(param)
            && param._links.hasOwnProperty('uploaded_file')) {
          formControl.get('value').setValue(param._links.uploaded_file.href);
        } else {
          formControl.get('value').setValue(param.value);
        }

        this._dataTableSource = [
          ...this._dataTableSource,
          {
            label: param.label,
            description: param.description,
            parent: this.getParentLabel(param),
            value: param.value,
            formControl: formControl,
            parameter: param,
          }
        ]
      });
    }
  }

  onSubmit(event) {
    const requests = [];
    const updatedParams = [];

    const formArray = this.form.controls['parameters'] as FormArray;
    for (let i = 0; i < formArray.length; i++) {
      if (formArray.at(i).dirty) {
        const param = this._parameters[i];
        const newParamValue = formArray.at(i).value.value;
        requests.push(this.parametersService.save(param, newParamValue));
        formArray.at(i).markAsPristine();
      }
    }

    Observable.forkJoin(requests)
      .subscribe((multiple) => {
        this.notification.success('Update successful', 'Successfully updated ' + multiple.length + ' parameters');
        this.afterUpdate.emit(multiple as Parameter[]);
      })
    ;
  }

  private getParentLabel(param: Parameter) {
    if (param._links.ggw_device) {
      return param._links.ggw_device.label;
    } else if (param._links.owning_unit) {
      return param._links.owning_unit.label;
    } else if(param._links.owning_service) {
      return param._links.owning_service.label;
    } else if(param._links.owning_port) {
      return param._links.owning_port.label;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/parameters/components/input-parameter-list/input-parameter-list.component.ts